import { termsAndConditionsSectionValidationMap } from './sections/termsAndConditionsSection/validations';
import { wegDataCompletionSectionValidationMap } from './sections/wegDataCompletionSection/validations';
import { wegSearchSectionValidationMap } from './sections/wegSearchSection/validations';

export const hausbankCompanyDataFieldValidation = {
  ...wegSearchSectionValidationMap,
  ...wegDataCompletionSectionValidationMap,
  ...termsAndConditionsSectionValidationMap,
};
